import { useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { queryFn, getDefault, Outcome } from './queryFn';

const getTimeSeriesPeriodMap = (date?: Date) => {
  const now = date || new Date();
  const TY = now.getFullYear();
  const TM = now.getMonth();
  const TD = now.getDate();
  return {
    '7D': new Date(TY, TM, TD - 7).getTime(), // 7 days ago
    // '1M': new Date(TY, TM - 1, TD).getTime(), // 1 month ago
    '3M': new Date(TY, TM - 3, TD).getTime(), // 3 months ago
    '1Y': new Date(TY - 1, TM, TD).getTime(), // 1 year ago
    // '2Y': new Date(TY - 2, TM, TD).getTime(), // 2 years ago
    // '3Y': new Date(TY - 3, TM, TD).getTime(), // 3 years ago
    // '5Y': new Date(TY - 5, TM, TD).getTime(), // 5 years ago
    // '10Y': new Date(TY - 10, TM, TD).getTime(), // 10 years ago
    // YTD: new Date(TY, 0, 1).getTime(), // Year to the day
    MAX: Infinity, // A long, long time ago
    NOW: now.getTime(),
  };
};

type Period = keyof ReturnType<typeof getTimeSeriesPeriodMap>;

export const getPeriodLabel = (period: Period) => {
  switch (period) {
    case '7D':
      return 'Seven days';
    case '3M':
      return 'Three months';
    case '1Y':
      return 'One year';
    case 'MAX':
      return 'All time';
  }
};

const getQueryKey = (
  companyId: string,
  timestamp = 0,
  lookup: number
): [string, string, number, number] => [
  'price-history',
  companyId,
  timestamp,
  lookup,
];

export const usePriceHistoryData = (companyId: string, period: Period) => {
  const { current: dateISOString } = useRef(new Date().toISOString());
  const today = dateISOString.substring(0, dateISOString.indexOf('T'));

  const { current: periodMap } = useRef(
    getTimeSeriesPeriodMap(new Date(today))
  );

  const { data = getDefault(), status } = useQuery({
    queryKey: getQueryKey(
      companyId,
      period === 'MAX' ? 0 : periodMap[period],
      periodMap.NOW
    ),
    queryFn,
    enabled: typeof companyId === 'string' && companyId !== '',
    staleTime: Infinity,
    retry: 1,
    refetchOnMount: false,
    notifyOnChangeProps: ['data', 'error'],
  });

  const isNegativeMovement = data?.movement === Outcome.NEGATIVE;

  return { data, periodMap, isNegativeMovement, status };
};
